<div
  style="page-break-inside: avoid;"
  class="mt-4"
  *ngIf="incomeFormFirmEtcData.length > 0"
  [ngClass]="{
    'container': true,
    'return-view-background-print': printActive,
    'return-view-background': !printActive
  }"
>
  <div class="row mb-4">
    <div class="col-12 text-center">
      <strong>PARTICULARS OF INCOME FROM FIRM, AOP, FOREIGN &amp; SPOUSE/MINOR</strong>
    </div>
  </div>

  <div class="row">
    <div class="col-sm-6">
      <strong>Taxpayer Name:</strong> {{ returnData?.profileData?.assesName }}
    </div>
    <div class="col-sm-6 text-right">
      <strong>Assessment Year:</strong> {{ returnData?.submissionInfo?.assessmentYear }}
    </div>
  </div>

  <div class="row mt-3 mb-5">
    <div class="col-sm-12">
      <strong>TIN</strong>
      <span class="ml-3" style="white-space: nowrap;">
        <input
          value="{{ tinChar }}"
          *ngFor="let tinChar of ((returnData?.profileData?.tin || '') + '').split('')"
          class="input-default"
          disabled
        />
      </span>
    </div>
  </div>

  <div *ngFor="let item of incomeFormFirmEtcData; let idx = index" style="page-break-inside: avoid;" class="row mb-5">
    <div class="col-12 mb-3 return-view-section-title">
      {{ getFirmEtcTypeTitle(getFirmEtcType(item)) }}
    </div>
    <div class="col-12 mb-3">
      <div class="return-view-text-fields">
        <ng-container *ngFor="let particular of getTextParticulars(item)">
          <div class="return-view-text-field" *ngIf="hasValue(item, particular.key)">
            <span class="return-view-text-label">{{ particular.title }}:</span>
            <span class="return-view-text-value">{{ getDisplayValue(item, particular) }}</span>
          </div>
        </ng-container>
      </div>
    </div>

    <div class="col-12" *ngIf="getAmountParticulars(item).length">
      <table class="table table-bordered income-firm-etc-table">
        <thead>
          <tr class="text-center">
            <th style="width: 70%">Particulars</th>
            <th style="width: 30%">Amount</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let particular of getAmountParticulars(item)">
            <ng-container *ngIf="hasValue(item, particular.key)">
              <td>{{ particular.title }}</td>
              <td class="text-right pr-3">{{ getValue(item, particular.key) | currencySeparatorBD }}</td>
            </ng-container>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
